import React, { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { images } from 'assets/themes';
import { auth } from 'services';
import useUniversalStore from 'store/universalStore';
import useOffcanvasStore from 'store/offcanvasStore';

function Header() {
    const { openOffcanvas } = useOffcanvasStore();
    const profile = useUniversalStore((state) => state.profile);

    return (
        <nav className="navbar navbar-expand bg-app">
            <div className="container-fluid">
                <span className="me-auto">
                    <Link className="navbar-brand" to="/" title="Home">
                        <img src={images.logo}
                            height="40" />
                        <span className="text-light mx-2"></span>
                    </Link>
                </span>
                <div className='d-none d-md-flex w-100'>
                    <div className="collapse navbar-collapse" id="myNav">
                        <ul className="navbar-nav me-auto">
                            <li className="nav-item mx-2">
                                <NavLink className="nav-link fs-6 text-light text-uppercase"
                                    to="/">
                                    Khatabook
                                </NavLink>
                            </li>
                            <li className="nav-item mx-2">
                                <NavLink className="nav-link fs-6 text-light text-uppercase"
                                    to="/cashbook">
                                    Cashbook
                                </NavLink>
                            </li>
                            <li className="nav-item mx-2">
                                <NavLink className="nav-link fs-6 text-light disabled text-uppercase"
                                    to="/passbook">
                                    Passbook{' '}
                                    <span className="bg-white text-dark badge">
                                        Coming Soon
                                    </span>
                                </NavLink>
                            </li>
                            <li className="nav-item mx-2">
                                <NavLink className="nav-link fs-6 text-light text-uppercase"
                                    to="/reports">
                                    Reports{' '}
                                </NavLink>
                            </li>
                        </ul>

                    </div>
                </div>
                <a className="nav-link text-light d-flex align-items-center"
                    onClick={() => openOffcanvas('menu')}
                    role="button">
                    <span className="fs-6 mx-3 d-none d-md-block">{profile?.get("businessName")}</span>
                    <i className="bi bi-person-circle fs-1 d-none d-md-block"></i>
                    <i className="bi bi-list fs-1 text-white d-md-none"></i>
                </a>
            </div>
        </nav>
    )
}
export default Header
